// Web-compatible device info implementation
export const DeviceInfo = {
  async getUniqueId(): Promise<string> {
    // Generate or retrieve a persistent device ID for web
    let deviceId = localStorage.getItem('web_device_id');
    if (!deviceId) {
      deviceId = 'web-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
      localStorage.setItem('web_device_id', deviceId);
    }
    return deviceId;
  },

  async getSystemName(): Promise<string> {
    return 'Web';
  },

  async getVersion(): Promise<string> {
    return '1.0.0'; // Web app version
  }
};

export default DeviceInfo;